export default "__VITE_ASSET__Dcfl$7Kl__"